import {gsap} from "gsap";
import App from "../../../../../templates/src/App/App";
import PinchZoom from "./pinchZoom";

const StockLocatorZoom = {
    current: 0,

    init(el) {
        this.el = el || $('[template="stock_locator"][page="detail"]');
        this.slider = this.el.find('[block="slider"] .slider');
        if (!this.slider.length) return;

        this.zoomInBtn = this.el.find('.button.zoom');
        this.prepare();
        this.bind();
    },

    prepare() {
        this.win = $('<div class="zoomer"></div>').prependTo(this.el);
        const inner = $('<div class="inner"></div>').appendTo(this.win);
        const scroller = $('<div class="scroller"></div>').appendTo(inner);
        this.closeBtn = $('<div class="button close size40 dark icon"></div>').appendTo(inner);
        this.images = this.slider.find('.owl-item').not('.cloned').find('img').clone();
        this.count = this.images.length - 1;
    },

    bind() {
        this.zoomInBtn.click((evt) => {
            this.create();
        })

        this.closeBtn.click((evt) => {
            this.hide();
        })
    },

    show() {
        $('body').css({overflow: 'hidden'});

        gsap.timeline()
            .to(this.win, {display: 'flex', opacity: 1}, 0)
            .to(this.win.find('.inner'), {opacity: 1, scale: 1}, 0.3)
    },

    hide() {
        // this.pinch.destroy();
        $('body').css({overflow: ''});
        gsap.timeline()
            .to(this.win, {display: 'none', opacity: 0}, 0.25)
            .to(this.win.find('.inner'), {
                opacity: 0, scale: 0.7, onComplete: () => {
                    this.win.find('.scroller').empty();
                }
            }, 0)
    },

    create(nmb) {
        let currentSlide = null;
        if (nmb) {
            currentSlide = this.slider.find('.owl-item').not('.cloned').find('.slide[order="' + nmb + '"]');
        } else {
            currentSlide = this.slider.find('.owl-item.active .slide');
        }

        if (App.isMobile) {
            this.createImage(currentSlide.find('img'));
            this.createNavigation();
            this.show();
        } else {
            this.createSlider(currentSlide);
        }
    },

    createImage(img, time = 300) {
        const holder = $('<div class="holder"></div>').appendTo(this.win.find('.scroller'));
        const image = img.clone().appendTo(holder);
        PinchZoom.init(image);

        setTimeout(() => {
            this.scrollImageToCenter();
        }, time);

        return holder;
    },

    scrollImageToCenter() {
        const left = Math.round(this.win.find('img').outerWidth() - window.innerWidth) / 2;
        gsap.to(this.win.find('.scroller'), {scrollTo: {x: left}, duration: 0.7})
    },

    createNavigation() {
        $('<div class="button next size40 dark icon"</div>')
            .click((evt) => {
                this.slide(1);
            })
            .appendTo(this.win);
        $('<div class="button back size40 dark icon"</div>')
            .click((evt) => {
                this.slide(-1);
            })
            .appendTo(this.win)
    },

    slide(i) {
        this.current += i;
        if (this.current > this.count) this.current = 0
        if (this.current < 0) this.current = this.count;

        PinchZoom.destroy();
        const newHolder = this.createImage($(this.images[this.current]), 0);
        gsap.fromTo(newHolder, {x: i * 100 + '%'}, {x: '0%', duration: 0.7})
    },

    createSlider(currentSlide) {
        const current = currentSlide.attr('order');
        const slider = $('<div class="slider"></div>').appendTo(this.win.find('.scroller'));

        this.images.each((i, el) => {
            let url = $(el).attr('src').split('?')[0];
            $(el).attr('src', url).appendTo(slider);
        })

        this.initSlider(slider, current);
    },

    initSlider(slider, current) {
        slider.addClass('owl-carousel')
            .on('initialized.owl.carousel', () => {
                setTimeout(() => {
                    this.show();
                }, 100)

            }).owlCarousel({
            "smartSpeed": 750,
            "loop": true,
            "autoWidth": false,
            // "autoHeight": true,
            "nav": true,
            "dots": true,
            "progress": true,
            "counter": false,
            "margin": 4,
            "stagePadding": -2,
            "items": 1,
            "navText": ["", ""],
            "current": current,
        })
            .on('change.owl.carousel', () => {
                setTimeout(() => {
                    this.scrollSliderToCenter();
                }, 100)
            })
            .trigger('to.owl.carousel', current);
    },

    scrollSliderToCenter() {
        if (this.win.find('.owl-stage').outerHeight() < window.innerHeight) return;
        const top = Math.round(this.win.find('.owl-stage').outerHeight() - window.innerHeight) / 2;
        gsap.to(this.win.find('.owl-stage-outer'), {scrollTo: {y: top}})
    },


}

export default StockLocatorZoom;